import styled from 'styled-components';

import CopyableField from 'dashboard/components/CopyableField';
import { ModalBody, ModalContainer, ModalFooter, ModalHeader } from 'dashboard/layouts/ModalLayout';
import { Inquiry } from 'dashboard/models/inquiry';
import { COLORS } from 'dashboard/styles/variables';
import Button from 'design-system/components/Button';
import { getRootDomain } from 'lib/utils/url';

const StyleWrapper = styled('a')`
  white-space: nowrap;

  input {
    color: ${COLORS.indigo80};
    cursor: pointer;
  }
`;

interface CopyInquiryLinkModalProps {
  handleClose: () => void;
  inquiry: Inquiry;
  subdomain: string;
  customDomain: string;
}

const CopyInquiryLinkModal = ({
  handleClose,
  inquiry,
  // TODO(neal): set the default value for subdomain to inquiry after subdomain rolled out
  subdomain,
  customDomain,
}: CopyInquiryLinkModalProps) => {
  let link;
  if (customDomain) {
    link = `${location.protocol}//${customDomain}/verify?inquiry-id=${inquiry.id}`;
  } else {
    link = `${location.protocol}//${subdomain ? subdomain + '.' : ''}${getRootDomain(
      location.host,
    )}/verify?inquiry-id=${inquiry.id}`;
  }

  return (
    <ModalContainer data-test='copy-inquiry-link-modal'>
      <ModalHeader data-test='copy-inquiry-link-modal__header' onClose={handleClose}>
        Copy Link
      </ModalHeader>
      <ModalBody>
        <StyleWrapper href={link} target='_blank'>
          <CopyableField
            id='copy-inquiry-link-modal__inquiry-link'
            data-test='copy-inquiry-link-modal__inquiry-link'
            value={link}
          />
        </StyleWrapper>
      </ModalBody>
      <ModalFooter>
        <Button data-test='copy-inquiry-link-modal__done' width='button' onClick={handleClose}>
          Done
        </Button>
      </ModalFooter>
    </ModalContainer>
  );
};

export default CopyInquiryLinkModal;
